import * as net from 'util/Net';

import {AnalyticsQuerySpecResponse} from './RESTAnalyticsQueryTypes';

export function cloneAnalyticsQuery(
  analyticsQueryId: string,
  data: {destinationDashboardId: string}
): Promise<AnalyticsQuerySpecResponse> {
  return net.postJSONPromise({
    url: `/1/api/analytics-queries/${analyticsQueryId}:clone`,
    data,
  });
}
